import ArticlesPage from './ArticlesPage';
import CreateLabelPage from './CreateLabelPage';
import CustomLabelPage from './CustomLabelPage';
import CustomizeLabelPage from './CustomizeLabelPage';
import EditLabelPage from './EditLabelPage';
import LabelsPage from './LabelsPage';
import PetSearchPage from './PetSearchPage';
import NoAccessPage from './NoAccessPage';
import AdvancedSettingsPage from './AdvancedSettingsPage'

export {ArticlesPage, CreateLabelPage, CustomLabelPage, CustomizeLabelPage, EditLabelPage, LabelsPage, PetSearchPage, NoAccessPage, AdvancedSettingsPage};


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/index.js
 **/